import React from 'react';
import { OpenFormButton } from '../ContactForm';

export default (props) => 
    (
	<section className="cta">

		<div className="container">

			<h3>Nation-wide and growing fast</h3>
			<p>Find out how you can switch on <a href="https://locations.blueshyft.com.au" target="_blank" className="link">1,500+ retail locations</a> for your business — overnight.</p>
			<OpenFormButton className="cta-button">LET'S TALK</OpenFormButton>

		</div>

	</section>
    )


// WEBPACK FOOTER //
// ./client/components/CTA/index.js